import lottie from 'lottie-web';
import 'waypoints/lib/jquery.waypoints';
import debounce from "debounce";

export default class Animations {
  constructor() {

    this.elements = document.getElementsByClassName('js-pattern');

    for (let i = 0, j = this.elements.length; i < j; i++) {
      this.init(this.elements[i]);
    }
  }

  // Check if item is in current viewPort
  inViewPort(element) {
    let rect = element.getBoundingClientRect();
    return (rect.top >= 0) && (rect.bottom <= window.innerHeight);
  }

  fileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();
    return ("404" !== xhr.status || 404 !== xhr.status);
  }

  init(element) {

    let self = this,
        patternColour = element.dataset.pattern || element.getAttribute('data-pattern');

    if (!patternColour) {
      patternColour = 'yellow';
    }

    let path = ajax_object.theme + '/dist/lottie/pattern-' + patternColour + '.json';

    // Return, since file in path does not exist
    if(false === this.fileExist(path)) {
      return;
    }


    let animation = lottie.loadAnimation({
      container: element,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: path
    })

    new Waypoint({
      element: element,
      handler: function (direction) {
        animation.play();
      },
      offset: '100%'
    });
    /*
      @todo: in future pause on stop-scrolling, when scrolling start playing again.
      window.addEventListener('scroll', debounce(function() {
        animation.play();
        if(true === self.inViewPort(element)) {
          animation.pause();
        }
      }), 100);
    */
  }
}
